<template>
    <v-row v-if="!$store.getters.progress" style="pb-offset">
        <v-col cols="12" class="pt-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p :class="{'pl-3': $vuetify.breakpoint.smAndUp, 'pl-2': $vuetify.breakpoint.smAndDown}">Impostazioni invio schede di sicurezza</p>
                    <v-spacer></v-spacer>
                </v-card-title>                   
                <v-divider></v-divider>
                <v-container class="pt-3 pb-0" fluid>
                    <fields-generator
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                        :file="{}"
                    ></fields-generator>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="margin:auto;" class="mr0i" text dark color="primary" @click.native="saveSettings">Salva
                    </v-btn>
                </v-card-actions>

                <v-snackbar
                    :timeout= 6000
                    color="success"
                    v-model="snackbar">
                    <span class="fw500">Impostazioni salvate </span>
                    <v-btn dark text @click.native="snackbar = false">Chiudi</v-btn>
                </v-snackbar>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue'

    export default {
        name: 'products-datasheet',
        props: {},
        data() {
            return {
                model: {},
                fieldsset: {},
                snackbar: false,
                modelDef: 'productsdatasheet',
            }
        },

        methods: {

            saveSettings() {
                let data = {model:this.modelDef}
                _.forEach(this.model, (value, key) => {
                    data[key] = value
                })

                this.axios.post('settings/', data).then(response => {
                    // get body data
                    this.snackbar = true
                }, response => {
                    // error callback
                })
            }
        },

        created() {

            this.axios.get(this.modelDef + '-info').then(response => {
                // get body data
                this.fieldsset = response.data.info
                this.axios.get('settings/'+this.modelDef).then(response => {

                    _.forEach(response.data.settings, (setting) => {
                        Vue.set(this.model, setting.key, setting.value)
                    })
                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })                

            }, response => {
                    // error callback
            });
        }

    }
</script>

<style scoped>

</style>